export default __webpack_public_path__ + "static/media/ScholarshipApplicationForm.a950bd38.pdf";